import { ArenaOpsMovementRowSchema } from "./arena-ops-filters.dto";
import { z } from "zod";

/** P7 — the global movement list. Keyset on `id DESC`, no OFFSET at any depth. */
export const ArenaOpsMoneyMovementsResponseSchema = z.object({
  rows: z.array(ArenaOpsMovementRowSchema),
  nextCursor: z.string().nullable(),
});
export type ArenaOpsMoneyMovementsResponse = z.infer<typeof ArenaOpsMoneyMovementsResponseSchema>;
